import TotalUser from "../../../assets/dashboard/TotalUser.jsx";
import Accounts from "../../../assets/dashboard/Accounts.jsx";
import Active from "../../../assets/dashboard/Active.jsx";
import Deposit from "../../../assets/wallet/Deposit.jsx";

export const getVolumeReportMetricCards = ({ summary, formatNumber }) => [
  {
    title: "Total Lots",
    value: formatNumber(summary?.totalLots),
    delta: summary?.totalLotsChangePercentsVsPreviousPeriod,
    icon: <Active color="#28C76F" />,
    bgColor: "bg-[#28c76f30]",
  },
  {
    title: "Closed PNL",
    value: `$${formatNumber(summary?.closedPnL, 2)}`,
    delta: summary?.closedPnLChangePercentsVsPreviousPeriod,
    icon: <Deposit color="#28C76F" />,
    bgColor: "bg-[#28c76f30]",
  },
  {
    title: "Trading Accounts",
    value: formatNumber(summary?.tradingAccounts),
    icon: <TotalUser color="#7367F0" />,
    bgColor: "bg-[#7367f038]",
  },
  {
    title: "Avg Volume / Client",
    value: `${formatNumber(summary?.avgLotsPerTradingAccount, 2)} lots`,
    icon: <Accounts color="#FF9F43" />,
    bgColor: "bg-[#ff9f432b]",
  },
];
